import React, { useEffect, useRef } from 'react';
import * as d3 from 'd3';

import { SCALE } from './constants';
import { FRAME_WIDTH, GAP } from './constants';
import { INITX, INITY } from './constants';
import { CANVASW, CANVASH } from './constants';

import { drawCasement } from './lib/drawCasement';
import { drawCasement2 } from './lib/drawCasement2';
import { drawFixedCasement } from './lib/drawFixedCasement';
import { drawSingleSlideTilt } from './lib/drawSingleSlideTilt';
import { drawDoubleSlideTilt } from './lib/drawDoubleSliderTilt';
import { drawAwning } from './lib/drawAwning';
import { drawPicture } from './lib/drawPicture';
import { drawVent } from './lib/drawVent';

import { drawHorizontalSections } from './lib/drawHorizontalSections';
import { drawTwoRowsSections } from './lib/drawTwoRowsSections';
import { displaySizes } from './lib/displaySizes';
import { calculatePanelDimensions } from './lib/displaySizes';
import { calculatePanelDimensions_real } from './lib/displaySizes';

import { drawArch } from './lib/drawArch';
import { drawMixedShape } from './lib/drawArch';

import { drawOculus } from './lib/drawOculus';
import DrawPatioDoor from './DrawPatioDoor';
import DrawPleatedScreen from './DrawPleatedScreen';


/*
const FRAME_WIDTH = 8;
const INITX = 60;
const INITY = 60;
const GAP   = 2;
*/

const DrawWindow = ({ doorData = null, toLeft = 0, zoom = 100, useStyle = true }) => {
  const svgRef = useRef(null);
  const canvasW = CANVASW;
  const canvasH = CANVASH;


  useEffect(() => {
    if (!doorData) return;

    //const svg = initSvg(); // ✅ move here
    const frameWidth = FRAME_WIDTH;
    let initX = INITX - toLeft;
    if (!doorData?.flipped) {
      initX = initX + 60;
    }
    const initY = INITY;
    const gap = GAP; //additional horizontal distance between sections.
    const nSections = doorData?.frameData?.nSections || 1;
    const { w_pure_r, w1_r, h1_r, w_label, h_label, uHeight_r, uHeight_label } 
    = calculatePanelDimensions_real(nSections, doorData, frameWidth, gap);    
    const { w_pure, w, h, w_label_s, h_label_s, uHeight } 
    = calculatePanelDimensions(nSections, doorData, frameWidth, gap);

    //const { w_pure, w, h, w_label, h_label } = calculatePanelDimensions( nSections, doorData, frameWidth, gap);
    if (doorData.frameData.upperSection === 1){
        doorData.frameData.uWidth1_d = w+2;
    }
    if (true) { 
      doorData.frameData.X = w; //doorData.frameData.uWidth1_d;
      doorData.frameData.Y = h; //doorData.frameData.h;
      doorData.frameData.w_pure = w_pure;
      //alert(w_pure)
    }
    //drawHorizontalSections(gap, initX, initY, nSections, svg, frameWidth, doorData);

    if (doorData?.document?.type === 'patiodoors'){
        const totalWidth = (parseFloat(doorData?.frameData?.unitWidth_d) || 72) * SCALE;
        const totalHeight = (parseFloat(doorData?.frameData?.unitHeight_d) || 80) * SCALE;
        doorData.frameData.X = totalWidth;
        doorData.frameData.Y = totalHeight;
        return; // Rendered by DrawPatioDoor component below
    }
    if (doorData?.document?.type === 'pleatedscreens'){
        return; // Rendered by DrawPleatedScreen component below
    }
    const svg = initSvg(); // ✅ move here
    drawTwoRowsSections(
      gap,     // gap
      initX,   // initX
      initY,   // initY
      nSections,
      svg,
      frameWidth,   // frameWidth
      doorData
    );

    //console.log ("uHeight:", uHeight);
    let offsetY =   uHeight + 2* frameWidth + gap;
    if (uHeight === 0) { offsetY = 0;}


    //1. Display casement if any...
    for (let i = 1; i <= nSections; i++) {
      drawCasement(nSections, i, svg, gap, initX, initY + offsetY, frameWidth, doorData);
      if (doorData?.frameData?.topRowConf === 'Grid') {
        drawCasement(nSections, i, svg, gap, initX, initY, frameWidth, doorData, true);
      }     
      if (doorData?.frameData?.topRowConf === '1' && i === 1 ) { // 1Section
        drawCasement(nSections, 1, svg, gap, initX, initY, frameWidth, doorData, true, true);
      }
    }//for
    //2. Display double casement if any...
    for (let i = 1; i <= nSections; i++) {
      drawCasement2(nSections, i, svg, gap, initX, initY + offsetY, frameWidth, doorData);
      if (doorData?.frameData?.topRowConf === 'Grid') {
        drawCasement2(nSections, i, svg, gap, initX, initY, frameWidth, doorData, true);
      }
      if (doorData?.frameData?.topRowConf === '1' && i === 1) { // 1Section
        drawCasement2(nSections, i, svg, gap, initX, initY, frameWidth, doorData, true, true);
      }
    }//for 
    //3. Display single slide tilt if any...
    for (let i = 1; i <= nSections; i++) {
      drawSingleSlideTilt(nSections, i, svg, gap, initX, initY + offsetY, frameWidth, doorData);
      if (doorData?.frameData?.topRowConf === 'Grid') {
        drawSingleSlideTilt(nSections, i, svg, gap, initX, initY, frameWidth, doorData, true);
      }
      if (doorData?.frameData?.topRowConf === '1' && i === 1 ) { // 1Section
        drawSingleSlideTilt(nSections, i, svg, gap, initX, initY, frameWidth, doorData, true, true);
      }
    }//for
    //3 b. Display double slide tilt if any...
    for (let i = 1; i <= nSections; i++) {
      drawDoubleSlideTilt(nSections, i, svg, gap, initX, initY + offsetY, frameWidth, doorData);
      if (doorData?.frameData?.topRowConf === 'Grid') {
        drawDoubleSlideTilt(nSections, i, svg, gap, initX, initY, frameWidth, doorData, true);
      }
      if (doorData?.frameData?.topRowConf === '1' && i === 1 ) { // 1Section
        drawDoubleSlideTilt(nSections, i, svg, gap, initX, initY, frameWidth, doorData, true, true);
      }
    }//for
    //4. Display Awning if any...
    for (let i = 1; i <= nSections; i++) {
      drawAwning(nSections, i, svg, gap, initX, initY + offsetY, frameWidth, doorData);
      if (doorData?.frameData?.topRowConf === 'Grid') {
        drawAwning(nSections, i, svg, gap, initX, initY, frameWidth, doorData, true);
      }
      if (doorData?.frameData?.topRowConf === '1' && i === 1 ) { // 1Section
        drawAwning(nSections, i, svg, gap, initX, initY, frameWidth, doorData, true, true);
      }
    }//for
    //5. Display Fixed casement if any...
    for (let i = 1; i <= nSections; i++) {
      drawFixedCasement(nSections, i, svg, gap, initX, initY + offsetY, frameWidth, doorData);
      if (doorData?.frameData?.topRowConf === 'Grid') {
        drawFixedCasement(nSections, i, svg, gap, initX, initY, frameWidth, doorData, true);
      }
      if (doorData?.frameData?.topRowConf === '1' && i === 1 ) { // 1Section
        drawFixedCasement(nSections, i, svg, gap, initX, initY, frameWidth, doorData, true, true);
      }
    }//for
    //6. Display Picture if any...
    for (let i = 1; i <= nSections; i++) {
      drawPicture(nSections, i, svg, gap, initX, initY + offsetY, frameWidth, doorData);
      if (doorData?.frameData?.topRowConf === 'Grid') {
        drawPicture(nSections, i, svg, gap, initX, initY, frameWidth, doorData, true);
      }
      if (doorData?.frameData?.topRowConf === '1' && i === 1 ) { // 1Section
        drawPicture(nSections, i, svg, gap, initX, initY, frameWidth, doorData, true, true);
      }
    }//for

    //. Display End-Vent if any...
    for (let i = 1; i <= nSections; i++) {
      drawVent(nSections, i, svg, gap, initX, initY + offsetY, frameWidth, doorData);
      if (doorData?.frameData?.topRowConf === 'Grid') {
        drawVent(nSections, i, svg, gap, initX, initY, frameWidth, doorData, true);
      }
      if (doorData?.frameData?.topRowConf === '1' && i === 1 ) { // 1Section
        drawVent(nSections, i, svg, gap, initX, initY, frameWidth, doorData, true, true);
      }
    }//for
    
    //21. Display Oculus if any...
    for (let i = 1; i <= nSections; i++) {
      drawOculus(nSections, i, svg, gap, initX, initY + offsetY, frameWidth, doorData);
      if (doorData?.frameData?.topRowConf === 'Grid') {
        drawOculus(nSections, i, svg, gap, initX, initY, frameWidth, doorData, true);
      }
      if (doorData?.frameData?.topRowConf === '1' && i === 1 ) { // 1Section
        drawOculus(nSections, i, svg, gap, initX, initY, frameWidth, doorData, true, true,
          /*outerShape = */'Half Round', 
          /*radiusX = null*/  doorData?.frameData.topRowHeight_d / 4, 
          /*radiusY = null,*/ doorData?.frameData.topRowHeight_d / 4,
          /*circleWidth =*/ frameWidth / 2
        );
      }
    }//for

    if (doorData?.flipped) {
      displaySizes(svg, initX, initY, w+2, h, w_label, h_label, uHeight, uHeight_label, frameWidth);        
      //displaySizes(svg, initX, initY, w+2, h, w_label, h_label, uHeight, frameWidth);
    }
    
  }, [doorData]);
  

 
  function initSvg() {
    // Clear and reinitialize SVG
    d3.select(svgRef.current).selectAll('*').remove();

    const svgElement = d3
      .select(svgRef.current)
      .attr('width',  ((doorData?.frameData?.X + INITX + 65) || canvasW) * zoom)
      .attr('height', ((doorData?.frameData?.Y + INITY + 50) || canvasH) * zoom)
      .style('border', '0px solid black');
      //.style('border', '1px solid black');

    // Create a scaled group for all drawings
    return svgElement
      .append('g')
      .attr('transform', `scale(${zoom})`);
  }

  //<p>Window Canvas (rectangle {canvasW}x{canvasH}) {/*JSON.stringify(doorData, null, 2)*/}</p>

  // Zoom is now applied to SVG dimensions directly, no need for CSS transform
  const style = {};


  if (doorData?.document?.type === 'patiodoors') {
    return <DrawPatioDoor doorData={doorData} toLeft={toLeft} zoom={zoom} useStyle={useStyle} />;
  }
  if (doorData?.document?.type === 'pleatedscreens') {
    return <DrawPleatedScreen doorData={doorData} toLeft={toLeft} zoom={zoom} useStyle={useStyle} />;
  }

  return (
    <div className="scaled-image"
    style={style}>
      <svg ref={svgRef}></svg>
    </div>
  );
};

export default DrawWindow;
